import { render } from "./CenteredText.vue?vue&type=template&id=32fa1772"
import script from "./CenteredText.vue?vue&type=script&lang=js"
export * from "./CenteredText.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__